import { useEffect } from "react";

/**
 * Swaps the browser tab title + favicon to the Bungalow Portal brand
 * while the user is on any /colonies/* page. Restores the original
 * favicon + title when unmounted so the pool business isn't left with
 * the wrong tab icon after navigating away.
 *
 * The favicon is an inline SVG (emerald-green Home glyph on a light
 * pill) served as a data URI, so no new binary asset is required.
 */
const COLONY_FAVICON =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <rect width="64" height="64" rx="12" fill="#047857"/>
      <path fill="#FFFFFF" d="M32 12 L54 30 h-6 v20 h-12 v-14 h-8 v14 H16 V30 H10 z"/>
    </svg>`
  );

const COLONY_TITLE = "Bungalow Portal — Management USA NJ";

export function useColonyBrand() {
  useEffect(() => {
    // Remember what was there so we can restore it on unmount.
    const prevTitle = document.title;
    const iconLinks = Array.from(
      // rel='icon' only — SVG apple-touch-icons break iOS Home Screen icons.
      document.querySelectorAll("link[rel='icon']")
    );
    const prevIcons = iconLinks.map((el) => ({
      el,
      href: el.getAttribute("href"),
      type: el.getAttribute("type"),
    }));

    document.title = COLONY_TITLE;
    // Point every existing icon link at the colony brand. Reusing the
    // existing <link> elements avoids Chrome's occasional stale-icon
    // caching when swapping between hostnames-with-same-path.
    iconLinks.forEach((el) => {
      el.setAttribute("href", COLONY_FAVICON);
      el.setAttribute("type", "image/svg+xml");
    });

    return () => {
      document.title = prevTitle;
      prevIcons.forEach(({ el, href, type }) => {
        if (href) el.setAttribute("href", href); else el.removeAttribute("href");
        if (type) el.setAttribute("type", type); else el.removeAttribute("type");
      });
    };
  }, []);
}
